"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuNumberPicker = exports.toAnchorDirection = exports.MenuNumberPickerContent = exports.toFlexDirection = exports.MenuNumberPickerContentContainer = exports.toRight = exports.toLeft = exports.toMarginLeft = exports.toTransform = exports.MenuNumberPickerContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const R = __importStar(require("ramda"));
const styled_components_1 = __importDefault(require("styled-components"));
const style_1 = __importDefault(require("style"));
const constant_1 = require("./constant");
const constant_2 = require("../constant");
const Menu_1 = require("../Menu");
const NumberButton_1 = require("./NumberButton");
const NumberDisplay_1 = require("./NumberDisplay");
const Container_1 = require("./Container");
const Flyout_1 = require("./Flyout");
exports.MenuNumberPickerContainer = styled_components_1.default.div `
  position: relative;
  display: inline-block;
  display: flex;
  align-items: center;
  justify-content: center;
`;
function toTransform({ anchor }) {
    switch (anchor) {
        case constant_2.HorizontalDirection.Left:
            return 'translate(-100%, -50%)';
        case constant_2.HorizontalDirection.Right:
            return 'translate(0%, -50%)';
        default:
            return 'none';
    }
}
exports.toTransform = toTransform;
function toMarginLeft({ anchor }) {
    switch (anchor) {
        case constant_2.HorizontalDirection.Right:
            return '100%';
        default:
            return 'auto';
    }
}
exports.toMarginLeft = toMarginLeft;
function toLeft({ anchor }) {
    switch (anchor) {
        case constant_2.HorizontalDirection.Left:
            return `-${style_1.default.Layout.Spacing.Small}`;
        case constant_2.HorizontalDirection.Right:
        default:
            return style_1.default.Layout.Spacing.Small;
    }
}
exports.toLeft = toLeft;
function toRight({ anchor }) {
    switch (anchor) {
        case constant_2.HorizontalDirection.Right:
            return style_1.default.Layout.Spacing.Small;
        case constant_2.HorizontalDirection.Left:
        default:
            return 'auto';
    }
}
exports.toRight = toRight;
exports.MenuNumberPickerContentContainer = styled_components_1.default.div `
  column-gap: ${style_1.default.Layout.Spacing.Small};
  display: flex;
  left: ${toLeft};
  margin-left: ${toMarginLeft};
  position: absolute;
  top: 50%;
  transform: ${toTransform};
  z-index: ${style_1.default.Depth.Position.F100};

  ${NumberButton_1.NumberButtonContainer} {
    ${style_1.default.Depth.Definition.Shadow};
  }
`;
function toFlexDirection({ direction }) {
    return direction === constant_2.HorizontalDirection.Right ? 'row-reverse' : 'auto';
}
exports.toFlexDirection = toFlexDirection;
const MenuNumberPickerContent = ({ anchor, onChange, value, values, }) => {
    return ((0, jsx_runtime_1.jsx)(exports.MenuNumberPickerContentContainer, Object.assign({ anchor: anchor }, { children: R.map((element) => {
            const isSelected = element === value;
            return ((0, jsx_runtime_1.jsx)(NumberButton_1.NumberButton, { isSelected: isSelected, isDisabled: isSelected, onClick: () => {
                    onChange(element);
                }, value: element }, `value-${element}`));
        }, values) })));
};
exports.MenuNumberPickerContent = MenuNumberPickerContent;
/**
 * Determine the anchor direction.
 */
function toAnchorDirection({ direction, side, }) {
    switch (side) {
        case constant_2.HorizontalDirection.Left:
            return direction === constant_2.HorizontalDirection.Left ? constant_2.HorizontalDirection.Right : constant_2.HorizontalDirection.Left;
        case constant_2.HorizontalDirection.Right:
        default:
            return direction === constant_2.HorizontalDirection.Right ? constant_2.HorizontalDirection.Left : constant_2.HorizontalDirection.Right;
    }
}
exports.toAnchorDirection = toAnchorDirection;
const MenuNumberPicker = (_a) => {
    var props = __rest(_a, []);
    const { useBackdrop, value, size, direction = constant_1.DEFAULT_DIRECTION } = props;
    return ((0, jsx_runtime_1.jsx)(exports.MenuNumberPickerContainer, { children: (0, jsx_runtime_1.jsx)(Container_1.NumberPickerContainer, Object.assign({}, props, { children: (containerProps) => {
                const { values, onChange } = containerProps;
                return ((0, jsx_runtime_1.jsx)(Menu_1.Menu, Object.assign({ useBackdrop: useBackdrop, content: (menuProps) => {
                        const { close } = menuProps;
                        const wrappedOnChange = (next) => {
                            onChange(next);
                            close();
                        };
                        return ((0, jsx_runtime_1.jsx)(Flyout_1.Flyout, { anchor: toAnchorDirection({ direction, side: constant_2.HorizontalDirection.Left }), onChange: wrappedOnChange, value: value, values: values }));
                    } }, { children: ({ toggle }) => {
                        return ((0, jsx_runtime_1.jsx)(NumberDisplay_1.NumberDisplay, { size: size, onClick: toggle, value: value }));
                    } })));
            } })) }));
};
exports.MenuNumberPicker = MenuNumberPicker;
